<form [formGroup]="form" class="outgoing-events-hybrid-tabs">
	<p-tabView [(activeIndex)]="selectedTabIndex">
		<p-tabPanel *ngFor="let tab of HYBRID_TAB_NAMES; let tabIndex = index" [header]="HYBRID_TAB_DISPLAY_NAMES[tab]">
			<div [formArrayName]="tab">
				<h4 class="text-center">Outgoing Events</h4>

				<p-table [value]="getFormArray(tab).controls" [scrollable]="true" scrollHeight="600px">
					<!-- Caption -->
					<ng-template pTemplate="caption">
						<div class="text-right">
							<button type="button" pButton label="Add Event" icon="pi pi-plus"
								class="p-button-sm p-button-outlined" (click)="onModifyProduct(tab, 'add')"></button>
						</div>
					</ng-template>

					<!-- Header -->
					<ng-template pTemplate="header">
						<tr>
							<th>Event Name</th>
							<th>Post If</th>
							<th class="text-center">Enabled</th>
							<th class="text-right">Actions</th>
						</tr>
					</ng-template>

					<!-- Body -->
					<ng-template pTemplate="body" let-group let-i="rowIndex">
						<tr [formGroupName]="i">
							<td>
								<p-dropdown [options]="config?.cmpRelation" formControlName="eventName"
									placeholder="-- Select Event --" optionLabel="label" optionValue="value"
									[style]="{ width: '100%' }"></p-dropdown>
							</td>
							<td>
								<p-dropdown [options]="config?.optionsPostIf" formControlName="postIf"
									placeholder="-- Select Post If --" [style]="{ width: '100%' }"></p-dropdown>
							</td>
							<td class="text-center">
								<p-checkbox [formControl]="getEnabledControl(tab, i)" 
									[binary]="true"
									[inputId]="'enabled-' + tab + '-' + i"></p-checkbox>
							</td>
							<td class="text-right">
								<button type="button" pButton icon="pi pi-trash"
									class="p-button-rounded p-button-text p-button-danger" 
									(click)="onModifyProduct(tab, 'delete', i)"
									pTooltip="Delete Row"></button>
							</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</p-tabPanel>
	</p-tabView>
</form>
